import { memo } from 'react';
import { Logo as BrandLogo, ILogo } from '@raiden-corp/rc-kit/components';

const Logo = (props: Omit<ILogo, 'innerText' | 'outerText'>) => {
  return <BrandLogo innerText="RDT" outerText="Rawand Dilan Therapy" {...props} />;
};

export default memo(Logo);
export type { ILogo };
